import React, { useState, useEffect, useCallback, useContext, useRef, useMemo } from "react";
import QuoteListNewBrand from "./QuoteListNewBrand";
import { useNavigate, useNavigation } from "react-router-dom";
import QuoteItemNewBrand from "./QuoteItemNewBrand";
import useHttp from "../../hooks/use-http";
import { SetAnalyticsData } from '../../util/SetAnalyticsData';
import { notification } from 'antd';

import styles from "./QuoteHistoryNewBrand.module.css";
import AppContext from "../../store/app-context";
import Breadcrumb from "../UI/Breadcrumb";
import Pagination from "../UI/Pagination";
import { parseCookies } from "nookies";
import { Info, Plus, Filter, Search, AlertCircle } from 'react-feather';
import Input from "../UI/Input";
import Modal from "../UI/Modal";
import Select from "../UI/Select";
import Tags from "../UI/Tags";
import FilterModal from "../UI/FilterModal";
import QuoteNotification from "./QuoteNotification";
import { Inform, Upload, Notify, Success, Quotecart, QuoteError } from '../Icons';

const QuoteHistoryNewBrand = (props) => {
  const navigation = useNavigation();
  const appCtx = useContext(AppContext);

  sessionStorage.removeItem("webReference");
  sessionStorage.removeItem("acctInfo");
  sessionStorage.removeItem("quote");

  const {
    sendRequest: getQuoteList,
  } = useHttp();
  const [newBrandStyle, setBrandStyle] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [quoteList, setQuoteList] = useState([]);
  const [isAPIError, setIsAPIError] = useState(false);
  const [searchErrorMsg, setSearchErrorMsg] = useState();
  const [fetchErroMessage, setFetchErrorMessage] = useState();
  const [searchResult, setSearchResult] = useState();
  const [statusOptions, setStatusOptions] = useState([]);
  const [deleteError, setDeleteError] = useState();
  const [enableQuoteDownload, setEnableQuoteDownload] = useState(false);
  const [exportStatus, setExportStatus] = useState(null);
  const [isExportModalVisible, setIsExportModalVisible] = useState(false);
  const [isRateLimitModal, setIsRateLimitModal] = useState(false);
  const pollIntervalRef = useRef(null);
  const previousStatusRef = useRef(null);

  const existCookies = parseCookies();

  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const quoteIdRef = useRef();
  const webReference = useRef();
  const dateLocaleRef = useRef("en-US");
  const searchHandlerRef = useRef();
  const notificationRef = useRef();

  const defaults = {
    quote_title: 'Quotes',
    home: 'Home',
    my_biorad: 'My Bio-Rad',
    start_quote: 'Start Quote',
    quote_number: 'Quote Number',
    search: 'Search',
    web_reference_number: 'Web Reference ID',
    sort_created_new_old: 'Date Created: Newest to Oldest',
    sort_created_old_new: 'Date Created: Oldest to Newest',
    sort_updated_new_old: 'Date Updated: Newest to Oldest',
    sort_updated_old_new: 'Date Updated: Oldest to Newest',
    quote_view: 'View',
    quote_sort: 'Sort',
    expand_view: 'Expand All',
    collapse_view: 'Collapse All',
    quote_filter: 'Filters',
    quote_result: 'results',
    quote_has_result: '{0} of {1} results',
    quote_no_result: 'Your quotes will appear here once they’ve been placed.',
    quote_no_search_result: 'No results found for "{0}"',
    quote_info_title: 'Recent quotes',
    quote_info_desc: 'Your quotes and their statuses will appear here after you create them.',
    quote_step_desc: 'Quote creation and approval process',
    step_create_title: 'Create quote request',
    step_create_desc: 'Add products to a quote as you would to a shopping cart from anywhere on the site.',
    step_submit_title: 'Submit quote request',
    step_submit_desc: "Submit your quote for review once you've added all desired products.",
    step_review_title: 'Review quote',
    step_review_desc: 'Our sales team will review your request and provide the best possible deal.',
    step_approve_title: 'Approve quote',
    step_approve_desc: "We'll notify you when your quote is approved.",
    step_order_title: 'Order from quote',
    step_order_desc: 'Place your order from approved quotes in your Quote History.',
    step_expiration_title: 'Quote expiration',
    step_expiration_desc: "All approved quotes have an expiration date. We'll notify you as the date approaches.",
    export_csv: 'Export as CSV File',
    export_processing: 'CSV Export Processing',
    export_completed: 'Export completed',
    export_failed: 'Export Failed',
    export_try_again: 'Please try again',
    export_modal_title: 'Export CSV File',
    export_modal_message_1: 'Your request is being created. If you applied filters, only quotes matching that filter will be included in the file.',
    export_modal_message_2: 'When your file is ready, a notification will appear at the top of the page with a download link.',
    export_modal_message_3: 'You can continue working while your request is processed.',
    export_modal_close: 'Close',
    export_rate_limit_message: 'You have reached the maximum allowable requests for this session. Please try again at a later time.',
  };
  
  let {
    quote_title,
    home,
    my_biorad,
    start_quote,
    quote_number,
    quote_has_result,
    search,
    web_reference_number,
    sort_created_new_old,
    sort_created_old_new,
    sort_updated_new_old,
    sort_updated_old_new,
    quote_view,
    quote_sort,
    expand_view,
    collapse_view,
    quote_filter,
    quote_result,
    quote_no_result,
    quote_no_search_result,
    quote_info_title,
    quote_info_desc,
    quote_step_desc,
    step_create_title,
    step_create_desc,
    step_submit_title,
    step_submit_desc,
    step_review_title,
    step_review_desc,
    step_approve_title,
    step_approve_desc,
    step_order_title,
    step_order_desc,
    step_expiration_title,
    step_expiration_desc,
    export_csv,
    export_processing,
    export_completed,
    export_failed,
    export_try_again,
    export_modal_title,
    export_modal_message_1,
    export_modal_message_2,
    export_modal_message_3,
    export_modal_close,
    export_rate_limit_message
  } = defaults;

  if (appCtx?.bioradResources) {
    quote_title = appCtx.bioradResources.QuoteTitle ?? quote_title;
    home = appCtx.bioradResources.Home ?? home;
    my_biorad = appCtx.bioradResources.MyBioRad ?? my_biorad;
    start_quote = appCtx.bioradResources.StartQuote ?? start_quote;
    quote_number = appCtx.bioradResources.QuoteNumber ?? quote_number;
    search = appCtx.bioradResources.Search ?? search;
    quote_has_result = appCtx.bioradResources.QuoteHasResult ?? quote_has_result;
    web_reference_number = appCtx.bioradResources.WebReferenceID ?? web_reference_number;
    sort_created_new_old = appCtx.bioradResources.SortCreatedNewOld ?? sort_created_new_old;
    sort_created_old_new = appCtx.bioradResources.SortCreatedOldNew ?? sort_created_old_new;
    sort_updated_new_old = appCtx.bioradResources.SortUpdatedNewOld ?? sort_updated_new_old;
    sort_updated_old_new = appCtx.bioradResources.SortUpdatedOldNew ?? sort_updated_old_new;
    quote_view = appCtx.bioradResources.QuoteView ?? quote_view;
    quote_sort = appCtx.bioradResources.QuoteSort ?? quote_sort;
    expand_view = appCtx.bioradResources.ExpandView ?? expand_view;
    collapse_view = appCtx.bioradResources.CollapseView ?? collapse_view;
    quote_filter = appCtx.bioradResources.QuoteFilter ?? quote_filter;
    quote_result = appCtx.bioradResources.QuoteResult ?? quote_result;
    quote_no_result = appCtx.bioradResources.QuoteNoResult ?? quote_no_result;
    quote_no_search_result = appCtx.bioradResources.QuoteNoSearchResult ?? quote_no_search_result;
    quote_info_title = appCtx.bioradResources.QuoteInfoTitle ?? quote_info_title;
    quote_info_desc = appCtx.bioradResources.QuoteInfoDesc ?? quote_info_desc;
    quote_step_desc = appCtx.bioradResources.QuoteStepDesc ?? quote_step_desc;
    step_create_title = appCtx.bioradResources.QuoteStepCreateTitle ?? step_create_title;
    step_create_desc = appCtx.bioradResources.QuoteStepCreateDesc ?? step_create_desc;
    step_submit_title = appCtx.bioradResources.QuoteStepSubmitTitle ?? step_submit_title;
    step_submit_desc = appCtx.bioradResources.QuoteStepSubmitDesc ?? step_submit_desc;
    step_review_title = appCtx.bioradResources.QuoteStepReviewTitle ?? step_review_title;
    step_review_desc = appCtx.bioradResources.QuoteStepReviewDesc ?? step_review_desc;
    step_approve_title = appCtx.bioradResources.QuoteStepApproveTitle ?? step_approve_title;
    step_approve_desc = appCtx.bioradResources.QuoteStepApproveDesc ?? step_approve_desc;
    step_order_title = appCtx.bioradResources.QuoteStepOrderTitle ?? step_order_title;
    step_order_desc = appCtx.bioradResources.QuoteStepOrderDesc ?? step_order_desc;
    step_expiration_title = appCtx.bioradResources.QuoteStepExpTitle ?? step_expiration_title;
    step_expiration_desc = appCtx.bioradResources.QuoteStepExpDesc ?? step_expiration_desc;
    export_csv = appCtx.bioradResources.ExportCSV ?? export_csv;
    export_processing = appCtx.bioradResources.ExportProcessing ?? export_processing;
    export_completed = appCtx.bioradResources.ExportCompleted ?? export_completed;
    export_failed = appCtx.bioradResources.ExportFailed ?? export_failed;
    export_try_again = appCtx.bioradResources.ExportTryAgain ?? export_try_again;
    export_modal_title = appCtx.bioradResources.ExportModalTitle ?? export_modal_title;
    export_modal_message_1 = appCtx.bioradResources.ExportModalMessage1 ?? export_modal_message_1;
    export_modal_message_2 = appCtx.bioradResources.ExportModalMessage2 ?? export_modal_message_2;
    export_modal_message_3 = appCtx.bioradResources.ExportModalMessage3 ?? export_modal_message_3;
    export_modal_close = appCtx.bioradResources.ExportModalClose ?? export_modal_close;
    export_rate_limit_message = appCtx.bioradResources.ExportRateLimitMessage ?? export_rate_limit_message;
  }

  const searchOptions = [
    {
      label: quote_number,
      value: 'quote_number'
    },
    {
      label: web_reference_number,
      value: 'web_reference_number'
    }
  ]

  const sortOptions = useMemo(() => [
    {
      label: sort_created_new_old,
      value: 'createDate_desc'
    },
    {
      label: sort_created_old_new,
      value: 'createDate_asc'
    },
    {
      label: sort_updated_new_old,
      value: 'updateDate_desc'
    },
    {
      label: sort_updated_old_new,
      value: 'updateDate_asc'
    }
  ], [sort_created_new_old, sort_created_old_new, sort_updated_new_old, sort_updated_old_new]);

  const [selectedSearchOption, setSelectedSearchOption] = useState(searchOptions[0].value);
  const [selectedSortOption, setSelectedSortOption] = useState(sortOptions[0].value);
  const [filterRange, setFilterRange] = useState({});
  const [filterStatus, setFilterStatus] = useState([]);
  const [shouldSearch, setShouldSearch] = useState(false);
  const [isSearch, setSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState();

  useEffect(() => {
    if (!shouldSearch) return;
    handleFormSubmit();
    setShouldSearch(false);
  }, [appCtx?.expanded, filterRange, filterStatus, selectedSortOption, shouldSearch]);

  const computeStatusOptions = (quotes) => {
    if (!quotes) return;
    const newStatusOptions = quotes.userStatus.map((status) => {
      return {
        label: status,
        value: status,
      };
    });
    setStatusOptions(newStatusOptions);
  };

  searchHandlerRef.current = async (searchCriteria, fromSearch) => {
    //console.log("searchCriteria: " + JSON.stringify(searchCriteria));
    setSearchErrorMsg(null);
    setIsLoading(true);

    const formatStatus = (str) => {
      if (!str) return '';
      const words = str.toLowerCase().split('_');
      return words[0].charAt(0).toUpperCase() + words[0].slice(1) + ' ' + words.slice(1).join(' ');
    };

    const setQuotes = (quotes) => {
      const qeVoList = quotes && quotes.qeVoList ? quotes.qeVoList : null;
      const quoteItemList = qeVoList.map((quote, _id) => (
        <QuoteItemNewBrand
          key={quote.webReference ? quote.webReference : quote.quoteId}
          created={quote?.formattedCreateDate ?? ''}
          webReference={quote.webReference}
          quoteId={quote.quoteId}
          name={quote.name}
          expiryDate={quote?.formattedExpiryDate ?? ''}
          status={quote?.quoteStatus ? formatStatus(quote.quoteStatus) : ''}
          locked={quote.locked}
          items={quote.items}
          background={_id % 2 === 0 ? "background1" : "background2"}
          isOpen={
            appCtx?.expanded === "expand"
              ? true
              : appCtx?.expanded === "collapse"
                ? false
                : _id === 0}
          onDeleteSuccess={() => setShouldSearch(true)}
          onDeleteError={handleDeleteError}
        />
      ));
      setQuoteList(quoteItemList);
      if (quotes) {
        setSearchResult(quotes);
      }
      computeStatusOptions(quotes);
      setIsLoading(false);
    };

    if (fromSearch &&
      (!searchCriteria ||
        (!searchCriteria.qid &&
          !searchCriteria.webRef &&
          !searchCriteria.dateStart &&
          !searchCriteria.dateEnd &&
          !searchCriteria.status &&
          !searchCriteria.sort))
    ) {
      setSearchErrorMsg("Please select at least one search criteria");
      setIsLoading(false);
      return;
    }

    let dateStart = filterRange?.from
      ? (filterRange.from instanceof Date
        ? filterRange.from.toISOString().split("T")[0]
        : new Date(filterRange.from).toISOString().split("T")[0])
      : undefined;

    let dateEnd = filterRange?.to
      ? (filterRange.to instanceof Date
        ? filterRange.to.toISOString().split("T")[0]
        : new Date(filterRange.to).toISOString().split("T")[0])
      : undefined;

    const qidParam = "qid=" + (searchCriteria.qid ? searchCriteria.qid : "");
    const webRefParam =
      "&webRef=" + (searchCriteria.webRef ? searchCriteria.webRef : "");
    const dateStartParam =
      "&dateS=" + (searchCriteria.dateStart ? searchCriteria.dateStart : dateStart ?? "");
    const dateEndParam =
      "&dateE=" + (searchCriteria.dateEnd ? searchCriteria.dateEnd : dateEnd ?? "");
    const statusParam =
      "&status=" + (searchCriteria.status ? searchCriteria.status : "");
    const sizeParam =
      "&size=" + (searchCriteria.size ? searchCriteria.size : 10);
    const pageParam =
      "&page=" + (searchCriteria.page ? searchCriteria.page : page ?? 1);
    const sortParam =
      "&sort=" + (searchCriteria.sort ? searchCriteria.sort : sortOptions[0].value);

    const searchServiceURL =
      "/quoteservices/rfqs/search2?" +
      qidParam +
      webRefParam +
      dateStartParam +
      dateEndParam +
      statusParam +
      sortParam +
      sizeParam +
      pageParam;

    const response = await fetch(searchServiceURL);
    const data = await response.json();
    if (!response.ok) {
      setIsAPIError(true);
      setIsLoading(false);
      if (data && data.status === "fail") {
        setSearchErrorMsg(data.message);
      } else {
        setSearchErrorMsg("Error fetching quotes");
      }
      setQuoteList([]);
      setSearchResult([]);
    } else {
      if (data && data.status === "fail") {
        setSearchErrorMsg(data.message);
        setQuoteList([]);
        setSearchResult([]);
      } else {
        setIsAPIError(false);
        setQuotes(data);
      }
    }

    if (isSearch) {
      window.digitalData = window.digitalData || [];
      window.digitalData.push({
        event: 'searchQuotes',
        search: {
          term: searchCriteria.qid || searchCriteria.webRef || '',
          parameter: selectedSearchOption,
          numberOfResults: data?.total || 0,
        },
      });

      (window.dataLayer = window.dataLayer || []).push({ event: 'searchQuotes' });
      setSearch(false);

      console.log('adobe - searchQuote', window.digitalData);
      if (!data?.total || data.total < 1) {
        if (quoteIdRef?.current) {
          quoteIdRef.current.value = '';
        }
        if (webReference?.current) {
          webReference.current.value = '';
        }
      }
    }

    setIsLoading(false);
  }

  const newSearch = (e) => {
    if (e?.preventDefault) e.preventDefault();
    let qid = quoteIdRef?.current?.value?.trim();
    let webRef = webReference?.current?.value?.trim();
    setSearchTerm(qid ? qid : webRef ? webRef : '');
    if (qid || webRef) {
      localStorage.setItem('expanded', '');
      setSelectedSortOption(sortOptions[0].value);
      localStorage.setItem('sortOption', sortOptions[0].value);
      setFilterRange({});
      localStorage.setItem('dateRange', '');
      setFilterStatus([]);
      localStorage.setItem('filterStatus', JSON.stringify([]));
    }
    setPage(1);
    setSearch(true);
    setShouldSearch(true);
    setExportStatus(null);
  }

  const handleFormSubmit = useCallback((e) => {
    if (e?.preventDefault) e.preventDefault();

    let qid = quoteIdRef?.current?.value?.trim();
    let webRef = webReference?.current?.value?.trim();
    let dateStart = filterRange?.from
      ? (filterRange.from instanceof Date
        ? filterRange.from.toISOString().split("T")[0]
        : new Date(filterRange.from).toISOString().split("T")[0])
      : undefined;

    let dateEnd = filterRange?.to
      ? (filterRange.to instanceof Date
        ? filterRange.to.toISOString().split("T")[0]
        : new Date(filterRange.to).toISOString().split("T")[0])
      : undefined;
    let status = filterStatus?.length > 0 ? filterStatus.join(",") : null;
    let sort = selectedSortOption;

    const searchCriteria = {
      ...(qid && { qid }),
      ...(webRef && { webRef }),
      ...(dateStart && { dateStart }),
      ...(dateEnd && { dateEnd }),
      ...(status && { status }),
      ...(sort && { sort })
    };

    searchHandlerRef.current?.(searchCriteria, true);
  }, [filterRange, filterStatus, selectedSortOption]);

  const handleSearchOptionChange = (option) => {
    setSelectedSearchOption(option);
  };
  const handleSortOptionChange = (option) => {
    setSelectedSortOption(option);
    localStorage.setItem('sortOption', option);
    setShouldSearch(true);
    setExportStatus(null);
  };
  const handleFilterChange = ({ range, status, reset }) => {
    setFilterRange(range);
    setFilterStatus(status);
    localStorage.setItem('dateRange', JSON.stringify(range));
    localStorage.setItem('filterStatus', JSON.stringify(status));
    if (reset) {
      if (quoteIdRef?.current) {
        quoteIdRef.current.value = '';
      }
      if (webReference?.current) {
        webReference.current.value = '';
      }
      setIsModalOpen(false);
      setSearchTerm('');
    }
    setPage(1);
    setShouldSearch(true);
    setExportStatus(null);
  };
  const handleStatusRemove = (statusToRemove) => {
    setFilterStatus((prev) => {
      const updated = prev.filter((s) => s !== statusToRemove);
      localStorage.setItem('filterStatus', JSON.stringify(updated));
      return updated;
    });
    setPage(1);
    setShouldSearch(true);
    setExportStatus(null);
  };
  const handleDateRemove = () => {
    setFilterRange({});
    localStorage.setItem('dateRange', '');
    setPage(1);
    setShouldSearch(true);
    setExportStatus(null);
  };

  const handleDeleteError = (msg) => {
    setDeleteError(msg);
  };

  const cntryLang = appCtx.lang.toLowerCase() + "-" + appCtx.country.toLowerCase();

  useEffect(() => {
    const saved = localStorage.getItem('expanded');
    if ((saved === 'expand' || saved === 'collapse') && appCtx.expanded !== saved) {
      appCtx.setExpanded(saved);
    } else {
      appCtx.setExpanded(null);
    }
    setSelectedSortOption(localStorage.getItem('sortOption') ?? sortOptions[0].value);
    const savedRange = localStorage.getItem('dateRange');
    setFilterRange(savedRange ? JSON.parse(savedRange) : {});
    const savedStatus = localStorage.getItem('filterStatus');
    setFilterStatus(savedStatus ? JSON.parse(savedStatus) : []);
    setShouldSearch(true);
  }, []);

  useEffect(() => {
    if (!appCtx.envProp) return;
    setBrandStyle(existCookies.rebrandEnabled
      ? existCookies.rebrandEnabled
      : appCtx?.envProp?.react_app_new_brand_style ? appCtx?.envProp?.react_app_new_brand_style : "false");
    setEnableQuoteDownload(appCtx?.envProp?.react_app_enable_quote_download === "true");
    if (newBrandStyle === 'true') {
      if (deleteError) {
        const timer = setTimeout(() => setDeleteError(null), 5000);
        return () => clearTimeout(timer);
      }
      dateLocaleRef.current = appCtx.lang.toLowerCase() + "-" + appCtx.country.toUpperCase();
      fetch(appCtx.envProp.webServer + 'standalone/my-biorad/leftnav.page', { credentials: 'include' })
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const navElement = doc.querySelector('#block-biorad-content');
          if (navElement) {
            // document.querySelector('.my-nav').append(navElement);
            // jQuery('.my-nav').html(navElement.outerHTML);
            document.querySelector('.my-nav').innerHTML = navElement.outerHTML;
            const target = document.querySelector('.my-nav');

            if (target) {
              const currentPath = window.location.pathname;
              const links = target.querySelectorAll('a[href]');

              links.forEach(link => {
                const linkPath = new URL(link.href, window.location.origin).pathname;
                const quoteAppRegex = /^\/quote-app\/quotes(\/[^\/]*)?$/;

                if (linkPath === currentPath || (quoteAppRegex.test(currentPath) && quoteAppRegex.test(linkPath))) {
                  link.classList.add('active');
                }
              });

              // handle script tags
              const executeScripts = (container) => {
                const scripts = container.querySelectorAll('script');
                
                scripts.forEach(originalScript => {
                  const newScript = document.createElement('script');
                  
                  Array.from(originalScript.attributes).forEach(attr => {
                      newScript.setAttribute(attr.name, attr.value);
                  });
                  
                  if (originalScript.textContent) {
                      let scriptContent = originalScript.textContent.trim();
                      
                      // Replace $(document).ready() with $(function()) 
                      // $(function()) executes immediately if DOM is ready, unlike $(document).ready() 
                      // which may not fire if DOM is already ready when jQuery loads
                      scriptContent = scriptContent.replace(
                        /\$\(document\)\.ready\s*\(\s*function\s*\(\s*\)\s*\{/g,
                        '$(function() {'
                      );
                      
                      // Ensure jQuery is available when script executes
                      // Since we're in React's useEffect, DOM is already ready
                      if (scriptContent.includes('$(') || scriptContent.includes('jQuery(')) {
                        scriptContent = `(function() {
                          var $ = window.jQuery || window.$;
                          if (typeof $ === 'function' && typeof checkNotificationFlag === 'function') {
                            ${scriptContent}
                          } else {
                            // Wait a bit for jQuery if not immediately available
                            var attempts = 0;
                            var checkJQuery = setInterval(function() {
                              attempts++;
                              $ = window.jQuery || window.$;
                              if (typeof $ === 'function' && typeof checkNotificationFlag === 'function') {
                                clearInterval(checkJQuery);
                                ${scriptContent}
                              } else if (attempts >= 50) {
                                // Give up after 10 second (50 * 200ms)
                                clearInterval(checkJQuery);
                                console.warn('jQuery not available after waiting, script may not execute');
                              }
                            }, 200);
                          }
                        })();`;
                      }
                      
                      newScript.textContent = scriptContent;
                  }
  
                  originalScript.parentNode.replaceChild(newScript, originalScript);
                });
              };
              executeScripts(target);
            }
          }
        })
        .catch((err) => {
          console.error('Failed to load navigation:', err);
        });
    }
  }, [appCtx.envProp.webServer, appCtx.lang, appCtx.country, newBrandStyle, deleteError]);

  useEffect(() => {
    const formatStatus = (str) => {
      if (!str) return '';
      const words = str.toLowerCase().split('_');
      return words[0].charAt(0).toUpperCase() + words[0].slice(1) + ' ' + words.slice(1).join(' ');
    };
    const setQuotes = (quotes) => {
      const qeVoList = quotes && quotes.qeVoList ? quotes.qeVoList : null;
      let quoteItemList = [];
      if (qeVoList) {
        quoteItemList = qeVoList.map((quote, _id) => (
          <QuoteItemNewBrand
            key={quote.webReference ? quote.webReference : quote.quoteId}
            created={quote?.formattedCreateDate ?? ''}
            webReference={quote.webReference}
            quoteId={quote.quoteId}
            name={quote.name}
            expiryDate={quote?.formattedExpiryDate ?? ''}
            status={quote?.quoteStatus ? formatStatus(quote.quoteStatus) : ''}
            locked={quote.locked}
            items={quote.items}
            background={_id % 2 === 0 ? "background1" : "background2"}
            isOpen={
              appCtx?.expanded === "expand"
                ? true
                : appCtx?.expanded === "collapse"
                  ? false
                  : _id === 0}
            onDeleteSuccess={() => setShouldSearch(true)}
            onDeleteError={handleDeleteError}
          />
        ));
      }
      setQuoteList(quoteItemList);
      if (quotes) {
        setSearchResult(quotes);
      }
      computeStatusOptions(quotes);
      setIsLoading(false);
    };

    setShouldSearch(true);
    setIsLoading(false);
  }, [appCtx?.expanded, getQuoteList]);

  useEffect(() => {
    return () => {
      stopPolling();
    };
  }, [stopPolling]);

  const paginationHandler = (nextPage) => {
    if (searchResult && searchResult.searchParams) {
      const searchParams = searchResult.searchParams;
      const pageNo = searchParams.page ? searchParams.page + nextPage : 1;
      searchParams['page'] = pageNo;
      searchHandlerRef.current?.(searchParams, false);
    }
  }

  const rangeText = () => {
    let pageSize = searchResult?.searchParams?.size ?? 1;
    let totalResults = searchResult?.total ?? 0;
    let page = searchResult?.searchParams?.page ?? 1;
    if (totalResults > 0) {
      const start = (page - 1) * pageSize + 1;
      const end = Math.min(page * pageSize, totalResults);
      return `${quote_has_result.replaceAll('{0}', start + '-' + end).replaceAll('{1}', totalResults)}`;
    }
    return `${totalResults} ${quote_result}`;
  };

  const calculatePollingInterval = useCallback((recordCount) => {
    if (!recordCount || recordCount === 0) {
      return 5000;
    }
    const MIN_INTERVAL = 3000;
    const MAX_INTERVAL = 30000;
    const SECONDS_PER_RECORD = 1;
    const estimatedSeconds = recordCount * SECONDS_PER_RECORD;
    const interval = Math.floor(estimatedSeconds / 5) * 1000;
    const calculatedInterval = Math.max(MIN_INTERVAL, Math.min(interval, MAX_INTERVAL));
    return calculatedInterval;
  }, []);

  const downloadFile = useCallback((requestId) => {
    const downloadURL = `${appCtx.envProp.appServer}etlapi/user/v1/biorad/export/download/${requestId}`;
    window.location.href = downloadURL;
  }, [appCtx.envProp.appServer]);

  const stopPolling = useCallback(() => {
    if (pollIntervalRef.current) {
      clearInterval(pollIntervalRef.current);
      pollIntervalRef.current = null;
    }
  }, []);

  const resetStatus = useCallback((resetDelay = 5000) => {
    setTimeout(() => {
      setExportStatus(null);
      previousStatusRef.current = null;
    }, resetDelay);
  }, []);

  const handleTerminalStatus = useCallback((status, data, requestId) => {
    stopPolling();

    if (status === 'COMPLETED') {
      if (notificationRef.current?.refetchNotifications) {
        notificationRef.current.refetchNotifications();
      }

      if (data.recordCount === 0) {
        
      } else if (data.recordCount > 0 && requestId) {
        downloadFile(requestId);
        
      }
      resetStatus(5000);
    } else if (status === 'FAILED') {
      if (notificationRef.current?.refetchNotifications) {
        notificationRef.current.refetchNotifications();
      }
      resetStatus(30000);
    }
  }, [stopPolling, downloadFile, resetStatus, export_completed, export_failed]);

  const startPollingWithInterval = useCallback((requestId, interval, shouldStartPolling = false) => {
    const poll = async () => {
      try {
        const response = await fetch(`/etlapi/user/v1/biorad/export/status/${requestId}`, {
          method: 'GET',
          mode: 'cors',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const data = await response.json();
        const status = data.status;

        setExportStatus(status);

        if (status === 'PENDING' || status === 'PROCESSING') {
          if (!pollIntervalRef.current) {
            pollIntervalRef.current = setInterval(poll, interval);
          }
        } else {
          handleTerminalStatus(status, data, requestId);
        }
        previousStatusRef.current = status;
      } catch (error) {
        console.error('Error polling export status:', error);
        setExportStatus('FAILED');
        previousStatusRef.current = 'FAILED';
        handleTerminalStatus('FAILED', {}, null);
      }
    };

    poll();

    if (shouldStartPolling) {
      pollIntervalRef.current = setInterval(poll, interval);
    }
  }, [handleTerminalStatus]);

  const handleCloseExportModal = useCallback(() => {
    setIsExportModalVisible(false);
    setIsRateLimitModal(false);
  }, []);

  const handleRetryExport = useCallback(() => {
    setExportStatus(null);
    handleDownloadCSV();
  }, []);

  const handleDownloadCSV = useCallback(async () => {
    try {
      setExportStatus('PENDING');
      setIsExportModalVisible(true);

      const searchParams = searchResult?.searchParams || {};

      const exportRequestBody = {
        documentType: "QUOTE",
        qid: searchParams.qid || "",
        webRef: searchParams.webRef || "",
        dateStart: searchParams.dateS || searchParams.dateStart || "",
        dateEnd: searchParams.dateE || searchParams.dateEnd || "",
        status: searchParams.status || "",
        sort: searchParams.sort || ""
      };

      const submitResponse = await fetch('/etlapi/user/v1/biorad/export/submit', {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(exportRequestBody)
      });

      if (!submitResponse.ok) {
        if (submitResponse.status === 429) {
          setIsRateLimitModal(true);
          setIsExportModalVisible(true);
          setExportStatus(null);
          
          return;
        }

        setExportStatus('FAILED');
       
        return;
      }

      const submitData = await submitResponse.json();

      if (!submitData || !submitData.requestId) {
        setExportStatus('FAILED');
        return;
      }

      const submitRequestId = submitData.requestId;

      if (notificationRef.current?.refetchNotifications) {
        notificationRef.current.refetchNotifications();
      }

      const processResponse = await fetch(`/quoteservices/rfqs/export/process/${submitRequestId}`, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!processResponse.ok) {
        setExportStatus('FAILED');
        return;
      }

      const processData = await processResponse.json();

      if (!processData || !processData.requestId) {
        setExportStatus('FAILED');
        return;
      }

      const pollingRequestId = processData.requestId;
      const pollingInterval = calculatePollingInterval(searchResult?.total || 100);
      startPollingWithInterval(pollingRequestId, pollingInterval, false);

    } catch (err) {
      setExportStatus('FAILED');
      console.error(err);
    }
  }, [searchResult, calculatePollingInterval, startPollingWithInterval, export_failed]);

  const myBioRadLink = appCtx.envProp.appServer + "bc/" + cntryLang + "/my-biorad";

  SetAnalyticsData();

  const orderSteps = [
    {
      icon: Inform,
      title: step_create_title,
      description: step_create_desc,
      color: '#E0F2FD'
    },
    {
      icon: Upload,
      title: step_submit_title,
      description: step_submit_desc,
      color: '#FFF1CE'
    },
    {
      icon: Notify,
      title: step_review_title,
      description: step_review_desc,
      color: '#C3DFD1'
    },
    {
      icon: Success,
      title: step_approve_title,
      description: step_approve_desc,
      color: '#E0F2FD'
    },
    {
      icon: Quotecart,
      title: step_order_title,
      description: step_order_desc,
      color: '#C3DFD1'
    },
    {
      icon: QuoteError,
      title: step_expiration_title,
      description: step_expiration_desc,
      color: '#C3DFD1'
    }
  ]

  if (newBrandStyle === 'true') {
    return (
      <div className={styles.pageLayout}>
        <div className="my-nav">
        </div>
        <div className={styles.pageContent}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <a href="/">{home}</a>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <a href={myBioRadLink}>{my_biorad}</a>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {quote_title}
            </Breadcrumb.Item>
          </Breadcrumb>
          <React.Fragment>
            {isLoading && !isAPIError && <p className={styles.loading_ring}></p>}
            {isModalOpen && (
              <div className="modal-backdrop">
                <FilterModal
                  initialRange={filterRange}
                  initialStatus={filterStatus}
                  onFilterChange={handleFilterChange}
                  onClose={() => setIsModalOpen(false)}
                  locale={dateLocaleRef.current}
                  statusOptions={statusOptions}
                />
              </div>
            )}
            {showModal && (
              <Modal onClose={() => setShowModal(false)} quoteInfo={true}>
                <div className={styles.modalContainer}>
                  <button
                    className={styles.closeButton}
                    onClick={() => setShowModal(false)}
                    aria-label="Close"
                  >
                    X
                  </button>

                  <h2 className={styles.mainTitle}>{quote_info_title}</h2>
                  <div className={styles.mainDescription}>{quote_info_desc}</div>

                  <div className={styles.trackingProcess}>
                    <h3 className={`${styles.stepDesc} ${styles.sectionTitle}`}>{quote_step_desc}</h3>

                    <div className={styles.stepsContainer}>
                      {orderSteps.map((step, index) => {
                        const IconComponent = step.icon;
                        return (
                          <div key={step.title} className={styles.stepItem}>
                            <div
                              className={styles.stepIcon}
                              style={{ backgroundColor: step.color }}
                            >
                              <IconComponent size={18} />
                            </div>
                            <div className={styles.stepContent}>
                              <p className={styles.stepTitle}>{step.title}</p>
                              <p className={styles.stepDescription}>{step.description}</p>
                            </div>
                            {index < orderSteps.length - 1 && (
                              <div className={styles.stepConnector} />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </Modal>

            )}
            {isExportModalVisible && (
              <Modal onClose={handleCloseExportModal}>
                <div className={styles.modalContainer}>
                  <button
                    className={styles.closeButton}
                    onClick={handleCloseExportModal}
                    aria-label="Close"
                  >
                    X
                  </button>
                  <h2 className={styles.mainTitle}>
                    {export_modal_title}
                  </h2>
                  <div className={styles.mainDescription}>
                    {isRateLimitModal ? (
                      <p className={styles.firstLine}>{export_rate_limit_message}</p>
                    ) : (
                      <>
                        <p className={styles.firstLine}>{export_modal_message_1}</p>
                        <p>{export_modal_message_2}</p>
                        <p>{export_modal_message_3}</p>
                      </>
                    )}
                  </div>
                  <div className={styles.modalFooter}>
                    <button
                      className={styles.modalCloseButton}
                      onClick={handleCloseExportModal}
                    >
                      {export_modal_close}
                    </button>
                  </div>
                </div>
              </Modal>
            )}
            {navigation.state === "loading" && (
              <p className={styles.loading_ring}></p>
            )}
            <div className={styles.quote}>
              <h1 className={styles.headingTitle}>
                {quote_title}
                <div className={styles.infoIcon} onClick={() => setShowModal(true)}><Info height={16} width={16} /></div>
              </h1>
              <button
                className={styles.btnRounded}
                onClick={() => navigate('/')}
              >
                <Plus height={16} width={16} />
                {start_quote}
              </button>
            </div>
            <QuoteNotification ref={notificationRef}></QuoteNotification>
            <div className={styles.Filter}>
              <form onSubmit={newSearch}>
                <div className={styles.inputContainer}>
                  <div className={styles.searchSelect}>
                    <Select options={searchOptions}
                      type='search'
                      value={selectedSearchOption}
                      onChange={handleSearchOptionChange} />
                  </div>
                  <div className={styles.childGroup}>
                    {["quote_number", { value: "quote_number" }].includes(selectedSearchOption) ?
                      <Input
                        ref={quoteIdRef}
                        className={styles.searchInput}
                        placeholder={search}
                        input={{
                          id: "quoteID",
                          type: "text",
                          name: "quoteID",
                        }}
                      /> :
                      <Input
                        ref={webReference}
                        className={styles.searchInput}
                        placeholder={search}
                        input={{
                          id: "webRef",
                          type: "text",
                          name: "webRef",
                        }} />
                    }
                    <button type="submit" className={styles.searchIcon}>
                      <Search width={16} height={16} />
                    </button>
                  </div>
                </div>
              </form>
              <div className={styles.flexDiv}>
                <div className={styles.view}>
                  <p className={styles.label}>{quote_sort}</p>
                  <Select options={sortOptions}
                    // disabled={!searchResult?.total}
                    value={selectedSortOption}
                    onChange={handleSortOptionChange} />
                </div>
                <div className={styles.view}>
                  <p className={styles.label}>{quote_view}</p>
                  <button
                    id={styles.filterButton}
                    // className={`${!searchResult?.total ? styles.disabled : ''} 
                    //       ${appCtx?.expanded === 'expand' ? styles.active : ''}`}
                    className={`${appCtx?.expanded === 'expand' ? styles.active : ''}`}
                    onClick={() => {
                      appCtx.setExpanded('expand');
                      localStorage.setItem('expanded', 'expand');
                    }}
                    // disabled={!searchResult?.total}
                  >
                    {expand_view}
                  </button>
                  <button
                    id={styles.filterButton}
                    // className={
                    //   `${!searchResult?.total ? styles.disabled : ''} 
                    //         ${appCtx?.expanded === 'collapse' ? styles.active : ''}`}
                    className={`${appCtx?.expanded === 'collapse' ? styles.active : ''}`}
                    onClick={() => {
                      appCtx.setExpanded('collapse');
                      localStorage.setItem('expanded', 'collapse');
                    }}
                    // disabled={!searchResult?.total}
                  >
                    {collapse_view}
                  </button>
                </div>
                <button id={styles.filterButton}
                  //disabled = {!searchResult?.total}
                  onClick={() => setIsModalOpen(true)}
                >
                  <Filter height={16} width={16} />
                  {quote_filter} {(filterRange?.from || filterRange?.to || (filterStatus?.length ?? 0) > 0) && (
                    <> ({(filterRange?.from || filterRange?.to ? 1 : 0) + (filterStatus?.length ?? 0)})</>
                  )}
                </button>
              </div>
            </div>
            <Tags
              filterStatus={filterStatus}
              filterRange={filterRange}
              onStatusRemove={handleStatusRemove}
              onDateRemove={handleDateRemove}
            />
            <div className={styles.quoteDetails}>
              <div className={styles.resultCounter}>
                <div className={styles.resultsLine}>
                  {rangeText()}
                  {enableQuoteDownload && searchResult?.total > 0 && (
                    <>
                      {' | '}
                      {!exportStatus && (
                        <span className={styles.exportLink} onClick={handleDownloadCSV}>
                          {export_csv}
                        </span>
                      )}
                      {(exportStatus === 'PENDING' || exportStatus === 'PROCESSING') && (
                        <span className={styles.exportStatus}>{export_processing}</span>
                      )}
                      {exportStatus === 'COMPLETED' && (
                        <span className={styles.exportStatus}>{export_completed}</span>
                      )}
                      {(exportStatus === 'FAILED' || exportStatus === 404) && (
                        <span className={styles.exportFailed}>
                          <span className={styles.exportFailedIcon}>
                            <AlertCircle width={18} height={18} />
                          </span>
                          {export_failed}{' '}
                          <span className={styles.exportLink} onClick={handleRetryExport}>
                            {export_try_again}
                          </span>
                        </span>
                      )}
                    </>
                  )}
                </div>
              </div>
              {quoteList && !quoteList.length > 0 && (
                <div className={styles.resultSet}>
                  {searchTerm?.trim() ? quote_no_search_result.replace('{0}', searchTerm) : quote_no_result}
                </div>
              )}
              {isAPIError && <p className={styles.errormsg}>{fetchErroMessage}</p>}
              {deleteError && <p className={styles.errormsg}>{deleteError}</p>}
              {!isLoading && !isAPIError && quoteList && quoteList.length > 0 && (
                <QuoteListNewBrand quoteList={quoteList} />
              )}
              {!isLoading && !isAPIError && quoteList && quoteList.length > 0 && (
                <div className={styles.pagination}>
                  <Pagination
                    page={page}
                    totalPages={searchResult.totalPage}
                    pageSize={searchResult.searchParams.size}
                    totalResults={searchResult.total}
                    onPageChange={(p) => {
                      setPage(p);
                      paginationHandler(p - page);
                    }}
                  />
                </div>
              )}
            </div>
          </React.Fragment>
        </div>
      </div>
    );
  }
};

export default QuoteHistoryNewBrand;
